import React, { useEffect, useState } from 'react';
import s from './StickyCta.module.css';

export default function StickyCta({ onOpenLead }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      const services = document.getElementById('services');
      const pastServices = services
        ? services.getBoundingClientRect().bottom < 0
        : window.scrollY > window.innerHeight * 3;
      const footer = document.getElementById('footer');
      const atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      setVisible(pastServices && !atFooter);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <button type="button" onClick={onOpenLead}
      className={`${s.button} ${visible ? s.visible : ''}`}
      aria-label="לתיאום שיחת ייעוץ">
      <span className={s.ring} />
      <span className={s.inner}>
        <span className={s.label}>לשיחת ייעוץ ללא עלות</span>
        <span className={s.arrow} aria-hidden="true">←</span>
      </span>
    </button>
  );
}
